export default {
  "form.error.invalidEmail": {
    en: "Type a valid email (your.name@domain.com)",
    es: "Escribe un email válido (ejemplo@ejemplo.com).",
  },
  "form.error.tooLong": {
    en: "This text is too long, make it shorter.",
    es: "Ese texto es demasiado largo, acórtalo.",
  },
  "form.error.required": {
    en: "To continue, fill this field.",
    es: "Para continuar, rellena este campo.",
  },

  "form.submit.saving": {
    en: "Saving...",
    es: "Guardando...",
  },
  "form.submit.save": {
    en: "Save",
    es: "Guardar",
  },
};
